export default {
  default: {
    primary: 'indigo',
    accent: 'pink'
  },
  red: {
    primary: 'red',
    accent: 'blue'
  },
  pink: {
    primary: 'pink',
    accent: 'teal'
  },
  purple: {
    primary: 'purple',
    accent: 'green'
  },
  deepPurple: {
    primary: 'deep-purple',
    accent: 'lime'
  },
  indigo: {
    primary: 'indigo',
    accent: 'pink'
  },
  blue: {
    primary: 'blue',
    accent: 'red'
  },
  lightBlue: {
    primary: 'light-blue',
    accent: 'orange'
  },
  cyan: {
    primary: 'cyan',
    accent: 'lime'
  },
  teal: {
    primary: 'teal',
    accent: 'pink'
  },
  green: {
    primary: 'green',
    accent: 'purple'
  },
  lightGreen: {
    primary: 'light-green',
    accent: 'yellow'
  },
  lime: {
    primary: 'lime',
    accent: 'deep-purple'
  },
  yellow: {
    primary: 'yellow',
    accent: 'light-green'
  },
  amber: {
    primary: 'amber',
    accent: 'cyan'
  },
  orange: {
    primary: 'orange',
    accent: 'light-blue'
  },
  deepOrange: {
    primary: 'deep-orange',
    accent: 'light-green'
  }
}



// WEBPACK FOOTER //
// ./src/config/themes.js